import React from 'react';

import Layout from '../components/Layout';
import PartialsHeader from '../components/Partials/PartialsHeader';
import Terms from '../components/Policy/Terms';

export default () => {
  return (
    <Layout
      title="Terms of Service - Ulam Labs"
      description="Terms of service explains how we treat your personal data and protect your privacy."
    >
      <PartialsHeader>
        <div className="container">
          <div className="content">
            <div className="body">
              <h1 className="title">
                Terms of Service <br /> of the ULAM LABS Website
              </h1>
            </div>
          </div>
        </div>
      </PartialsHeader>
      <Terms />
    </Layout>
  );
};
